/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Space_Files_Chip2_LabelInputs */



/**
* | output |
* | --- |
* | "Why can't the assistant find my file?" |
*
* @param {Uno_Edu_Space_Files_Chip2_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_space_files_chip2_label = /** @type {((inputs?: Uno_Edu_Space_Files_Chip2_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Space_Files_Chip2_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Warum findet der Assistent meine Datei nicht?")
	return /** @type {LocalizedString} */ ("Why can't the assistant find my file?")
});